import { render, staticRenderFns } from "./NationalTrademarkNoteForm.vue?vue&type=template&id=11084c84&"
import script from "./NationalTrademarkNoteForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkNoteForm.vue?vue&type=style&index=0&id=11084c84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports